import * as React from 'react';
import VariantImageForm from "../../components/VariantImages/VariantImageForm/VariantImageForm";
var VariantImage = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(VariantImageForm, null))))));
};
export default VariantImage;



//////////////////
// WEBPACK FOOTER
// ./src/views/VariantImages/VariantImage.tsx
// module id = 497
// module chunks = 0